import { render, staticRenderFns } from "./SubCategories.vue?vue&type=template&id=52dd708b&scoped=true"
import script from "./SubCategories.vue?vue&type=script&lang=js"
export * from "./SubCategories.vue?vue&type=script&lang=js"
import style0 from "./SubCategories.vue?vue&type=style&index=0&id=52dd708b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dd708b",
  null
  
)

export default component.exports